import { SITES_REFRESH_BUMP } from "../constants/sitesConstant";

const initialState = {
  refreshToken: 0,
};

export default function sitesReducer(state = initialState, action) {
  switch (action.type) {
    case SITES_REFRESH_BUMP:
      return { ...state, refreshToken: state.refreshToken + 1 };
    default:
      return state;
  }
}
